import { initializeApp } from "firebase/app";
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCKT09u7jcU0IVpykolmF4KGiy_SBHTuIA",
  authDomain: "globasa-519f1.firebaseapp.com",
  projectId: "globasa-519f1",
  storageBucket: "globasa-519f1.firebasestorage.app",
  messagingSenderId: "352399998788",
  appId: "1:352399998788:web:91034ef2e3683ad01e6111",
  measurementId: "G-SE3V7JEVTL"
};

const app = initializeApp(firebaseConfig);

// Some browsers (seen on OEM Android Chrome builds, e.g. Transsion/Tecno) block
// window.localStorage entirely, throwing a SecurityError on access. Firebase Auth's
// default persistence probing doesn't catch this, which crashes the whole app with a
// blank screen. Detect it up front and fall back to in-memory (session-only) auth.
function canUseWebStorage() {
  try {
    const testKey = "__gbs_storage_test__";
    window.localStorage.setItem(testKey, "1");
    window.localStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

export const auth = canUseWebStorage()
  ? initializeAuth(app, {
      persistence: [
        indexedDBLocalPersistence,
        browserLocalPersistence,
        browserSessionPersistence,
        inMemoryPersistence,
      ],
    })
  : initializeAuth(app, { persistence: inMemoryPersistence });

export const db = getFirestore(app);